module.exports = __webpack_public_path__ + "static/media/video_back_altern.86b2f94a.webm";